// li-funnel-redesign v2 — the Duolingo register flow adapted to LingoChat.
// The children are generated from the declarative step table in `steps.ts`, in
// flow order, so the A/B route config (which is derived from these paths) and
// `navigateToNextOnboardingPageAction` stay in sync with the rendered flow.

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'
import v2OnboardingSteps from './steps'
import V2OnboardingStep from './V2OnboardingStep'

const v2OnboardingRoutes = [
  {
    path: 'v2',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: v2OnboardingSteps.map((step, index) => ({
      action: navigateToNextOnboardingPageAction,
      // Consecutive steps of the same type render the same component at the
      // same spot in the tree, so without a per-step key React would keep the
      // previous screen's state (and its "already submitted" guard).
      element: (
        <V2OnboardingStep
          key={step.path}
          step={step}
          stepNumber={index + 1}
          totalSteps={v2OnboardingSteps.length}
        />
      ),
      path: step.path,
    })),
  },
]

export default v2OnboardingRoutes
